import { ElMessage } from "element-plus";
import { cacheSaveAppId, cacheSaveTargetUrl, getToken } from "./common";

export const jumpUrl = (url) => {
    if (url) {
        if (checkStringForPattern(url)) {
            const isLogin = handleAuthUrl(url)
            if (isLogin) {
                if(userInfo && !userInfo.name){
                    ElMessage('请完善信息后再试')
                    window.location.href='/personalInfo';
                    return;
                }
                window.location.href = '/auth/jump'
            }else{
                ElMessage('请登录后再点击跳转')
                window.location.href='/signin';
            }
        } else {
            window.location.href = url
        }
    }
}

export const jumpBlankUrl = (url, userInfo) => {
    if (url) {
        if (checkStringForPattern(url)) {
            const isLogin = handleAuthUrl(url)
            if (isLogin) {
                if(userInfo && !userInfo.name){
                    ElMessage('请完善信息后再试')
                    window.location.href='/personalInfo';
                    return;
                }
                window.open('/auth/jump', '_blank');
            }else{
                ElMessage('请登录后再点击跳转')
                window.location.href='/signin';
            }
        } else {
            window.open(url, '_blank');
        }
    }
}

const handleAuthUrl = (url) => {
    const token = getToken()
    if (!token) {
        ElMessage('请登录后再试')
        return false
    }
    const code = extractPatternContent(url);
    const targetUrl = removeCodeFromUrl(url);
    cacheSaveAppId(code)
    cacheSaveTargetUrl(targetUrl)
    return true
}


function removeCodeFromUrl(url) {
    // 正则表达式解释：
    // \{ 匹配左花括号
    // \d{10,32} 匹配 10 到 32 位的数字
    // \} 匹配右花括号
    const pattern = /\{\d{10,32}\}/g;
    return url.replace(pattern, '');
}


function extractPatternContent(str) {
    // 正则表达式解释：
    // \{ 匹配左花括号
    // (\d{10,32}) 捕获组，匹配 10 到 32 位的数字
    // \} 匹配右花括号
    const pattern = /\{(\d{10,32})\}/g;
    const matches = [];
    let match;

    // 使用循环提取所有匹配的内容
    while ((match = pattern.exec(str)) !== null) {
        matches.push(match[1]); // match[1] 是捕获组的内容
    }

    return matches.length > 0 ? matches : null;
}


function checkStringForPattern(str) {
    // 正则表达式解释：
    // \{ 匹配左花括号
    // \d{10,32} 匹配 10 到 32 位的数字
    // \} 匹配右花括号
    const pattern = /\{\d{10,32}\}/g;
    return pattern.test(str);
}